import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'auditAction'
})
export class AuditActionPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case 0:
        return 'Uploaded';
      case 1:
        return 'Download';
      case 2:
        return 'Viewed';
      case 3:
        return 'Modified';
      case 4:
        return 'Deleted';
      case 5:
        return 'AccessChangeGranted';
      case 6:
        return 'Commented';
      case 7:
        return 'CommentDeleted';
      case 8:
        return 'CommentModified';
      case 9:
        return 'Subscribed';
      case 10:
        return 'Unsubscribed';
      case 11:
        return 'ModifiedSettings';
      case 12:
        return 'UserGroupChange';
      case 13:
        return 'AssetVersionDeleted';
      case 14:
        return 'AssetFilesRemoved';
      case 15:
        return 'UserGroupAdded';
      case 16:
        return 'UserGroupDeleted';
      case 17:
        return 'TokenAddedToGroup';
    }
  }
}
